
const Logo = () => (
  <div className="">
    <h1 className="light-text-color h2">Legalide</h1>
  </div>
);

export default Logo;
